// components/Dashboard.js
import React from "react";

/**
 * Dashboard component
 * Displays user info, basic stats, and recent activity
 * Accepts `user` object and `onLogout` function via props
 */
const Dashboard = ({ user, onLogout }) => {
  /**
   * Attempts to retrieve user info from props or localStorage
   * Provides a fallback in case no data is available
   */
  const getUserInfo = () => {
    // Prefer user info passed via props
    if (user && (user.name || user.email)) {
      return user;
    }
    
    // Fallback to localStorage
    try {
      const storedUserInfo = localStorage.getItem("userInfo");
      if (storedUserInfo) {
        return JSON.parse(storedUserInfo);
      }
    } catch (e) {
      console.error("Error parsing stored user info:", e);
    }
    
    // Return default placeholder
    return { name: "User", email: "user@example.com" };
  };
  
  const userInfo = getUserInfo();

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="logo">Demo App</div>
        <div className="user-menu">
          <img 
            src={userInfo.picture} 
            alt="Profile" 
            className="profile-image"
          />
          <div className="user-info">
            <span className="user-name">{userInfo.name}</span>
            <button className="logout-button" onClick={onLogout}>Logout</button>
          </div>
        </div>
      </header>

      <div className="dashboard-container">
        <aside className="sidebar">
          <nav className="sidebar-nav">
            <ul>
              <li className="active">
                <a href="#dashboard">Dashboard</a>
              </li>
              <li>
                <a href="#profile">Profile</a>
              </li>
              <li>
                <a href="#settings">Settings</a>
              </li>
              <li>
                <a href="#analytics">Analytics</a>
              </li>
              <li>
                <a href="#help">Help & Support</a>
              </li>
            </ul>
          </nav>
        </aside>

        <main className="main-content">
          <div className="welcome-banner">
            <h1>Welcome, {userInfo.name}!</h1>
            <p>You've successfully logged in with Google authentication.</p>
          </div>

          <div className="stats-grid">
            <div className="stat-card">
              <h3>Projects</h3>
              <div className="stat-value">12</div>
            </div>
            <div className="stat-card">
              <h3>Tasks</h3>
              <div className="stat-value">34</div>
            </div>
            <div className="stat-card">
              <h3>Completed</h3>
              <div className="stat-value">28</div>
            </div>
            <div className="stat-card">
              <h3>Progress</h3>
              <div className="stat-value">82%</div>
            </div>
          </div>

          <div className="dashboard-section">
            <h2>Recent Activity</h2>
            <div className="activity-list">
              <div className="activity-item">
                <div className="activity-icon">📝</div>
                <div className="activity-details">
                  <h4>Project Updated</h4>
                  <p>You updated the "Marketing Campaign" project</p>
                  <span className="activity-time">2 hours ago</span>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">✅</div>
                <div className="activity-details">
                  <h4>Task Completed</h4>
                  <p>You completed the "Update documentation" task</p>
                  <span className="activity-time">Yesterday</span>
                </div>
              </div>
              <div className="activity-item">
                <div className="activity-icon">🔔</div>
                <div className="activity-details">
                  <h4>Reminder Set</h4>
                  <p>You set a reminder for the team meeting</p>
                  <span className="activity-time">2 days ago</span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <footer className="dashboard-footer">
        <p>&copy; 2025 Demo Application. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Dashboard;